import { URL_REGEX } from './regExp';

export function isValidURL(url: string): boolean {
  return url.match(URL_REGEX) !== null;
}
